/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
// import moment from 'moment';
import moment from 'moment-timezone';
import {validateField} from './validateModule';
import Vue from "vue";
import VueCookies from 'vue-cookies'

require('./bootstrap');

window.Vue = require('vue').default;

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

window.Laravel = {
    API_HOSTNAME: process.env.MIX_API_HOSTNAME,
}

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
    }
});

Vue.filter('formatDateShort', function (value) {
    if (value) {
        return moment(String(value)).format('DD.MM.YYYY HH:mm')
    }
});

Vue.filter('formatMoment', function (value, param) {
    if (value) {
        return moment(String(value)).format(param)
    }
});

Vue.filter('formatUTC', function (value) {
    if (value) {
        return moment(String(value)).tz('UTC').format()
    }
});

Vue.filter('formatDateSpan', function (value) {
    if (value) {
        const dt = moment(String(value))
        const utc = moment(String(value)).tz('UTC')
        return '<time datetime="' + utc.format() + '" title="' + utc.format() + '">'
            + '<span class="date">' + dt.format('YYYY-MM-DD') + '</span>'
            + '<span class="time text-black-50 ms-1">' + dt.format('HH:mm:ss') + '</span>'
            + '</time>'
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * E.g. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
Vue.component('user-access-list', require('./components/UserAccessList.vue').default);
Vue.component('promo-code-filter', require('./components/PromoCode/PromoCodeFilter.vue').default);
Vue.component('promo-code-table', require('./components/PromoCode/PromoCodeTable.vue').default);
Vue.component('switch-cookie', require('./components/SwitchCookie.vue').default);
Vue.component('choise', require('./components/Choise.vue').default);
Vue.component('user-subscription-table-row', require('./components/User/SubscriptionTableRow.vue').default);
Vue.component('user-subscription-table', require('./components/User/SubscriptionTable.vue').default);
Vue.component('user-connection-config', require('./components/User/ConnectionConfig.vue').default);
Vue.component('app-version-table', require('./components/AppVersion/AppVersionTable.vue').default);
Vue.component('app-version-table-row', require('./components/AppVersion/AppVersionTableRow.vue').default);
Vue.component('post-fields', require('./components/Post/PostFields.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

new Vue({
    el: '#app',
});

Vue.use(VueCookies)

document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.validate-form');

    forms.forEach((form) => {
        form.querySelectorAll('.validate-url').forEach((field) => {
            const handleInputChange = () => {
                validateField(field);
            };

            field.addEventListener('input', handleInputChange);
            field.addEventListener('change', handleInputChange);
        });

        form.addEventListener('submit', (event) => {
            event.preventDefault();

            let valid = true;

            form.querySelectorAll('.validate-url').forEach((field) => {
                if (!validateField(field)) {
                    valid = false;
                }
            });

            if (valid) form.submit();
        });
    });

    // Btn checkboxes group
    const checkboxes = document.querySelectorAll('.planet-check-group .btn-check');

    checkboxes.forEach(function (checkbox) {
        const label = document.querySelector(`label[for="${checkbox.id}"]`);

        if (checkbox.checked) {
            label.classList.add('btn-inverse-danger');
        } else {
            label.classList.remove('btn-inverse-danger');
        }

        checkbox.addEventListener('change', function () {
            if (checkbox.checked) {
                label.classList.add('btn-inverse-danger');
            } else {
                label.classList.remove('btn-inverse-danger');
            }
        });
    });
});